var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{attrs:{"variant":"danger","show":!!_vm.errors.length}},_vm._l((_vm.errors),function(error){return _c('span',{key:error,staticStyle:{"font-size":"0.8rem"}},[_vm._v(" "+_vm._s(error)+" "),_c('br')])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }